import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '~/lib/api-client';
import { researchKeys } from '~/lib/query-keys';

/**
 * Cancel a running deep-research run. Marks the row as `cancelled`
 * server-side; the stop is COOPERATIVE, not immediate (FRONT-186,
 * `src/research/cancellation.ts`): the runner's `checkCancelled` reads this
 * flag back at the engine's next stage boundary and bows out cleanly there,
 * so the run doesn't stop mid-step but does stop within roughly one stage.
 * The live card/banner goes away immediately once the invalidation lands,
 * ahead of the run underneath actually winding down.
 */
export function useCancelResearch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ runId }: { runId: number }) =>
      api.post(`/api/research/${runId}/cancel`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: researchKeys.all });
    },
    onError: (err) => {
      toast.error(`Cancel failed: ${(err as Error).message}`);
    },
  });
}
